import { GridIcon } from '@/features/experiences/components/Controls/controls/LayoutControl/GridIcon';
import { Flex } from '@/ui';

export const CalendarIcon = () => {
  return (
    <Flex alignItems="center" flexDir="column" gap="2px" w="100%">
      <GridIcon shapeProps={{ height: '8px' }} squareCols={1} squareRows={1} />
      <GridIcon shapeProps={{ height: '6px' }} squareCols={7} squareRows={5} />
    </Flex>
  );
};
